import React, {useContext, useMemo} from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import useSession from './useSession'

export {SESSION_STATE} from './useSession'

const SessionContext = React.createContext({
  error: null,
  loading: true,
  state: null,
  refresh: noop,
})

export const useSessionContext = () => useContext(SessionContext)

const Provider = ({children}) => {
  const {error, loading, state, refresh} = useSession()
  const contextValue = useMemo(
    () => ({error, loading, state, refresh}),
    [error, loading, state, refresh]
  )

  return (
    <SessionContext.Provider value={contextValue}>
      {children}
    </SessionContext.Provider>
  )
}

Provider.propTypes = {
  children: PropTypes.any,
}

export const SessionProvider = Provider
